import React from "react";
import { Button } from "react-bootstrap";

const Success = ({ warningMessage }) => {
  return (
    <div>
      <p style={{ fontSize: 17 }} className="text-dark">
        {
          "Uspješno ste se ažurirali klijenta. Za sve ostale radnje prijavite se na PFB portal na linku koji se dobili na mail unesen prilikom kreiranja podataka o vlasniku."
        }
      </p>

      {warningMessage && (
        <div className="invalid-record my-3 p-3">{warningMessage}</div>
      )}

      <Button
        onClick={() => {
          window.location.reload();
        }}
      >
        Dodaj novog
      </Button>
    </div>
  );
};

export default Success;
